import { createSlice } from '@reduxjs/toolkit';

interface DrugState {
  clearSearch: boolean;
  pageIndex: number;
}

const initialState: DrugState = {
  clearSearch: false,
  pageIndex: 0,
};

const drugSlice = createSlice({
  name: 'drug',
  initialState,
  reducers: {
    setPageIndex: (state, action) => {
      state.pageIndex = action.payload;
    },
    clearSearch: (state) => {
      state.clearSearch = true;
    },
    resetClearSearch: (state) => {
      state.clearSearch = false;
    },
  },
});

export const drugActions = drugSlice.actions;

export default drugSlice.reducer;
